import { createContext } from 'react';

export const DialogContext = createContext<{ destroy?: () => void }>({});
